import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'

var Http = {
  defaultTimeout: 20000
}

Http.ErrorCode = {
  NOT_NETWORK: -1, // 无网络,服务器无响应
  SERVICE_ERROR: -2, // 服务器错误，请求错误返回码不为：200
  PARSER_ERROR: -3, // 接口解析错误
  API_ERROR: -4, // 接口错误status不为：0
  REQUEST_ERROR: -5 // 请求之前错误，
}

/**
 *
 * @param error error对象
 * @param errorCode  Http.ErrorCode
 * @param request  请求对象
 * @param response 响应对象
 * @returns {*}
 * @constructor
 */
var creatHttpError = function (error, errorCode, request, response) {
  if (!error) {
    error = new Error()
  }
  error.errorCode = errorCode

  if (request) {
    error.request = request
  }

  if (response) {
    error.response = response
  }
  return error
}

// 创建新的实例
var axiosNew = axios.create({ timeout: Http.defaultTimeout})
axiosNew.defaults.withCredentials = true

// POST传参序列化(添加请求拦截器)
axiosNew.interceptors.request.use(
  config => {
    config.headers = {
      // 'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
    // 在发送请求之前做某件事
    if (
      config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'delete'
    ) {
      // 序列化
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    let httpError = creatHttpError(error, Http.ErrorCode.REQUEST_ERROR, error.request, error.response)
    return Promise.reject(httpError)
  }
)

// 返回状态判断(添加响应拦截器)
axiosNew.interceptors.response.use(
  res => {
    // 对响应数据做些事
    if (res.status == 200) {
      if (res.data.state == 0) {
        return res.data.data
      } else {
        // 接口state不为0

        let httpError = creatHttpError(new Error('Api Error:' + res.data.data), Http.ErrorCode.API_ERROR, res.request, res)
        return Promise.reject(res.data)
      }
    } else {
      let httpError = creatHttpError(new Error('Server Error:' + res.status), Http.ErrorCode.SERVICE_ERROR, res.request, res)
      return Promise.reject(res.data)
    }
  },
  error => {
    if (error.response) {
      // 服务器有响应
      let httpError = creatHttpError(error, Http.ErrorCode.SERVICE_ERROR, error.request, error.response)
      return Promise.reject(httpError)
    } else {
      // 无网络或者服务器无响应
      let httpError = creatHttpError(error, Http.ErrorCode.NOT_NETWORK, error.request, error.response)
      return Promise.reject(httpError)
    }
  }
)

/**
 this.$http.post(url,data).then((data)=>{

  }).catch((error)=>{

  })

 *
 * @param url
 * @param data
 * @returns {Promise<any>}
 */
Http.post = function (url, data) {
  return new Promise(function (resolve, reject) {
    axiosNew.post(url, data).then(function (data) {
      resolve(data)
    }).catch(function (error) {
      console.log('http-post-error:', error)
      reject(error)
    })
  })
}

/**
 this.$http.get(url,data).then((data)=>{

  }).catch((error)=>{

  })

 *
 * @param url
 * @param data
 * @returns {Promise<any>}
 */
Http.get = function (url, params) {
  return new Promise(function (resolve, reject) {
    axiosNew.get(url, {params: params}).then(function (data) {
      resolve(data)
    }).catch(function (error) {
      console.log('http-get-error:', error)
      reject(error)
    })
  })
}
// md5加密请求
Http.encryptRequest = function (config) {
  if (!config || !config.url || config.url == '') {
    return
  }
  if (!config.data) {
    config.data = {};
  }
  if (!config.params) {
    config.params = {};
  }
  let time = new Date().getTime()
  let signKey = 'hnb1001'
  let business = ''
  if (config.method == 'post') {
    business = config.data.hasOwnProperty('business') ? config.data.business : 1
  } else {
    business = config.params.hasOwnProperty('business') ? config.params.business : 1
  }
  let tempParams = {
    business: business,
    time: parseInt(time / 1000)
  }
  let configData = config.method == 'post' ? config.data : config.params
  configData = Object.assign(tempParams, configData)
  let orderParams = {}
  let orderStr = ''
  let paramsArr = Object.keys(configData)
  paramsArr.sort().forEach(function (key) {
    orderParams[key] = configData[key]
    let lastStr = Object.keys(orderParams).length == paramsArr.length ? '' : '&'
    if (typeof (configData[key]) == 'object') {
      let innerParams = {}
      let innerArr = Object.keys(configData[key])
      innerArr.forEach(function (inner) {
        innerParams[inner] = configData[key][inner]
        let innerLastStr = Object.keys(orderParams).length == paramsArr.length && Object.keys(innerParams).length == innerArr.length ? '' : '&'
        orderStr += encodeURIComponent(key + '[' + inner + ']') + '=' + encodeURIComponent(innerParams[inner]) + innerLastStr
      })
    } else {
      orderStr = orderStr + encodeURIComponent(key) + '=' + encodeURIComponent(configData[key]) + lastStr
    }
  })
  let signStr = orderStr.replace(/~/g, '%7E').replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
  replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+') + signKey
  configData.sign = md5(signStr)
  if (config.method == 'post') {
    config.data = JSON.parse(JSON.stringify(configData))
  } else {
    config.params = JSON.parse(JSON.stringify(configData))
  }
  let axiosConfig = {
    url: config.url,
    method: config.method || 'get',
    params: config.params || {},
    data: config.data || {},
    headers: config.headers || {},
  }

  if (config.cookie && config.cookie != '') {
    axiosConfig.headers.cookie = config.cookie
  }
  return new Promise(function (resolve, reject) {
    axiosNew(config).then(function (data) {
      resolve(data)
    }).catch(function (error) {
      // console.log('http-post-error:',error);
      reject(error)
    });
  })
}

export default Http
